import { css, cx } from '@repo/pandacss/styled-system/css';
import type { CSSProperties } from 'react';

export type StarIconSize = number | { xs: number; md: number };

const responsiveIconDimensions = css({
  width: { base: 'var(--star-icon-w)', md: 'var(--star-icon-w-md)' },
  height: { base: 'var(--star-icon-h)', md: 'var(--star-icon-h-md)' },
});

export const StarIcon = ({
  className,
  color,
  iconSize,
  testid,
}: {
  className?: string;
  color?: string;
  iconSize?: StarIconSize;
  testid?: string;
}) => {
  const starStyles = css({
    display: 'inline-block',
    lineHeight: 'xs',
    marginRight: '0.5',
    marginLeft: '[1px]',
    overflowX: 'hidden',
    overflowY: 'hidden',
    backgroundColor: 'neutral.dark',
    WebkitMaskImage:
      "[url(\"data:image/svg+xml;utf8, <svg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 20 19'><path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/></svg>\")]",
    maskImage:
      "[url(\"data:image/svg+xml;utf8, <svg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 20 19'><path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/></svg>\")]",
  });

  const isResponsiveObject = typeof iconSize === 'object' && iconSize !== null;
  const px = typeof iconSize === 'number' ? iconSize : iconSize === undefined ? 15 : undefined;

  return (
    <span
      className={cx(starStyles, isResponsiveObject && responsiveIconDimensions, className)}
      style={{
        ...(isResponsiveObject
          ? ({
              '--star-icon-w': `${iconSize.xs}px`,
              '--star-icon-h': `${iconSize.xs}px`,
              '--star-icon-w-md': `${iconSize.md}px`,
              '--star-icon-h-md': `${iconSize.md}px`,
            } as CSSProperties)
          : {
              width: `${px ?? 15}px`,
              height: `${px ?? 15}px`,
            }),
        ...(color !== undefined ? { background: color } : {}),
      }}
      data-testid={testid}
    />
  );
};
